import CleanDirPlugin from 'clean-webpack-plugin';

export default (cleanPaths = ['public'], opts) => (
  new CleanDirPlugin(cleanPaths, {
    root: process.cwd(),
    ...opts,
  })
);
